import React, { useState, useEffect } from 'react';
import Struct from '../../components/Struct';
import BasePage from '../../components/BasePage';
import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Input from "../../components/FormElements/Input"; 
import { callAPI } from '../../hooks/CallAPI';
import { useLocalStorage } from "../../hooks/useLocalStorage";
import { useNavigate } from "react-router-dom"; 
import { toast, ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import LoadingWrapper from '../../components/LoadingWrapper'; 

const NouveauTickets = (props) => {
    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const [user] = useLocalStorage("user", null);
    const navigate = useNavigate();

    const handleNewTicket = async (e) => {
        e.preventDefault();

        if (!title) {
            toast.warning('Veuillez sélectionner un titre pour votre demande')
            return false;
        }

        if (description.length < 20) {
            toast.warning('Votre demande doit contenir au moins 20 caractères')
            return false;
        }

        setIsLoading(true)
        const responseData = await callAPI('/create-ticket', { access_token: user.access_token, description: description, title: title });
        if (responseData.success == true) {
            setIsLoading(false)

            navigate('/tickets')
        }
    };

    
    const content = (data) => {

        return (

            <div id="nouveau-ticket">
                <form id="loginForm" className="m-4 my-10" onSubmit={handleNewTicket}>
                    
                    <Input 
                        name="titre"
                        label="Titre"
                        value={title}  
                        onChange={(e) => setTitle(e.target.value)}
                        type="select"
                        options={[
                            { id: '', name: 'Veuillez choisir un titre pour votre demande' },  // Option par défaut
                            ...data // Autres options
                        ]}
                    />

                    <Input
                        name="description"
                        label="Votre demande"
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        type="textarea"
                    />

                    <div className="relative">
                        
                            <button type="submit" className="bg-mlime px-6 py-4 rounded-3xl w-full max-w-lg flex items-center justify-center text-white font-bold text-center m-auto  duration-500 hover:bg-colorbutton">
                                <LoadingWrapper isLoading={isLoading}>
                                    Envoyer la demande <FontAwesomeIcon className="ml-3" icon="fa-regular fa-paper-plane" />
                                </LoadingWrapper>
                            </button>
                        
                    </div>
                </form>
            </div>
        )
    }

    return <BasePage url="/nouveau-ticket" content={content} title={props.title ?? 'Infos'} />;
}

export default NouveauTickets;